import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
import { Logo } from './ui/Logo';
import { cn } from '../utils/cn';
import { useLanguage } from '../context/LanguageContext';
export function Navbar() {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  const navLinks = [{
    name: t.nav.entorno,
    href: '#entorno'
  }, {
    name: t.nav.calidades,
    href: '#calidades'
  }, {
    name: t.nav.pisoPiloto,
    href: '#zonas-comunes'
  }, {
    name: t.nav.disponibilidad,
    href: '#disponibilidad'
  }, {
    name: t.nav.promotora,
    href: '#quienes-somos'
  }, {
    name: t.nav.contacto,
    href: '#contacto'
  }];
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (href: string) => {
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <header className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-300', isScrolled ? 'bg-white shadow-md py-4' : 'bg-transparent py-6')} data-id="element-273">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-274">
        <a href="#" onClick={e => {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }} className="transition-transform hover:scale-105" data-id="element-275">
          <Logo variant={isScrolled ? 'dark' : 'light'} data-id="element-276" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-277">
          <ul className="flex items-center gap-6" data-id="element-278">
            {navLinks.map(link => <li key={link.name} data-id="element-279">
                <a href={link.href} onClick={e => {
              e.preventDefault();
              scrollTo(link.href);
            }} className={cn('text-sm font-medium transition-colors hover:text-sand', isScrolled ? 'text-navy/80' : 'text-white/90 drop-shadow-sm')} data-id="element-280">
                  {link.name}
                </a>
              </li>)}
          </ul>

          {/* Desktop Lang Selector */}
          <div className="flex items-center gap-2 border-l border-white/20 pl-6 ml-2" data-id="element-281">
            <button onClick={() => setLang('es')} className={cn('text-sm font-bold transition-colors', lang === 'es' ? isScrolled ? 'text-navy' : 'text-white' : isScrolled ? 'text-navy/40' : 'text-white/50')} data-id="element-282">
              es
            </button>
            <span className={cn('text-sm', isScrolled ? 'text-navy/20' : 'text-white/20')} data-id="element-283">
              |
            </span>
            <button onClick={() => setLang('en')} className={cn('text-sm font-bold transition-colors', lang === 'en' ? isScrolled ? 'text-navy' : 'text-white' : isScrolled ? 'text-navy/40' : 'text-white/50')} data-id="element-284">
              en
            </button>
          </div>

          <Button variant={isScrolled ? 'primary' : 'secondary'} onClick={() => scrollTo('#contacto')} data-id="element-285">
            {t.nav.solicitarInfo}
          </Button>
        </nav>

        {/* Mobile Toggle + Lang Selector (outside the menu) */}
        <div className="lg:hidden flex items-center gap-3" data-id="element-286">
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2" data-id="element-287">
            {isMobileMenuOpen ? <X className={cn('w-6 h-6', isScrolled ? 'text-navy' : 'text-white')} data-id="element-288" /> : <Menu className={cn('w-6 h-6', isScrolled ? 'text-navy' : 'text-white')} data-id="element-289" />}
          </button>

          <div className="flex items-center gap-1.5" data-id="element-290">
            <button onClick={() => setLang('es')} className={cn('text-sm font-bold transition-colors', lang === 'es' ? isScrolled ? 'text-navy' : 'text-white' : isScrolled ? 'text-navy/40' : 'text-white/50')} data-id="element-291">
              es
            </button>
            <span className={cn('text-sm', isScrolled ? 'text-navy/20' : 'text-white/20')} data-id="element-292">
              |
            </span>
            <button onClick={() => setLang('en')} className={cn('text-sm font-bold transition-colors', lang === 'en' ? isScrolled ? 'text-navy' : 'text-white' : isScrolled ? 'text-navy/40' : 'text-white/50')} data-id="element-293">
              en
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-white shadow-xl border-t border-gray-100" data-id="element-294">
          <nav className="flex flex-col p-6 gap-4" data-id="element-295">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => {
          e.preventDefault();
          scrollTo(link.href);
        }} className="text-navy font-medium py-3 border-b border-gray-50" data-id="element-296">
                {link.name}
              </a>)}

            <Button className="mt-4 w-full h-12" onClick={() => scrollTo('#contacto')} data-id="element-297">
              {t.nav.solicitarInfo}
            </Button>
          </nav>
        </div>}
    </header>;
}